import type { BlueprintCasePhoto } from "../utils/postVisitBlueprintCases";

/**
 * Wellnest "Results like yours" curated patient cases.
 * Currently empty — no real before/after photos available yet.
 * Add entries here when Dr. Reddy provides actual patient photos.
 * An empty array hides the "Results like yours" section automatically.
 */
export const WELLNEST_CURATED_BLUEPRINT_CASES: BlueprintCasePhoto[] = [];
